<template>
    <div :class="['tab-pane', 'fade', active ? 'show active' : '']" id="user" role="tabpanel" aria-labelledby="user-tab">
        <div class="card card-settings">
            <div class="card-body col-md-6 m-auto py-5">
                <form class="needs-validation" @submit.prevent="changePassword">
                    <div class="mb-3">
                        <label for="oldPassword">Old Password</label>
                        <div class="input-group">
                        <div class="input-group-prepend">
                            <font-awesome-icon :icon="['fas', 'key']" class="input-group-text" size="xs"/>
                        </div>
                        <input type="password" class="form-control" id="oldPassword" v-model="oldPassword" required>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="newPassword">New Password</label>
                        <div class="input-group">
                        <div class="input-group-prepend">
                            <font-awesome-icon :icon="['fas', 'key']" class="input-group-text" size="xs"/>
                        </div>
                        <input type="password" class="form-control" id="newPassword" v-model="newPassword" required>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="confirmPassword">Confirm Password</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <font-awesome-icon :icon="['fas', 'key']" class="input-group-text" size="xs" />
                            </div>
                            <input type="password" class="form-control" id="confirmPassword" v-model="confirmPassword" required>
                        </div>
                    </div>
                    <div v-if="error" class="alert alert-danger alert-dismissible fade show" role="alert">
                        {{ error }}
                    </div>
                    <div v-if="success" class="alert alert-success alert-dismissible fade show" role="alert">
                        {{ success }}
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearSuccessMessage">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div v-if="submited" class="text-center">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <button v-else class="btn btn-primary btn-lg btn-block mt-4" type="submit" :disabled="!formIsValid">Save</button>
                    </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'UserSettings',
    props: ['active'],
    data: () => ({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        submited: false,
        success: undefined,
    }),
    computed: {
        ...mapGetters(['error']),
        formIsValid() {
            let fieldsOK = this.oldPassword.trim().length > 0 && this.newPassword.length > 0;
            let newPassOK = this.newPassword == this.confirmPassword;
            return fieldsOK && newPassOK;
        }
    },
    methods: {
        changePassword() {
            this.submited = true;
            this.$store.dispatch('changePassword', {'old': this.oldPassword, 'new': this.newPassword})
            .then(() => {
                if (!this.error) {
                    this.success = 'Password changed successfully';
                    this.oldPassword = '';
                    this.newPassword = '';
                    this.confirmPassword = '';
                }
                this.submited = false
            });
        },
        clearSuccessMessage() {
            this.success = undefined;
        }
    }
}
</script>